(function () {
  'use strict';

  function getFlyImage() {
    return document.querySelector('.product-slideshow .is-selected img')
      || document.querySelector('.product-slideshow img');
  }

  function flyToCart(sourceImg) {
    var cartIcon = document.querySelector('.js-drawer-open-cart');
    if (!sourceImg || !cartIcon || !window.Element.prototype.animate) {
      return;
    }

    var startRect = sourceImg.getBoundingClientRect();
    if (!startRect.width || !startRect.height) {
      return;
    }
    var endRect = cartIcon.getBoundingClientRect();

    var clone = document.createElement('div');
    clone.className = 'equipe-fly-to-cart';
    clone.style.backgroundImage = 'url(' + (sourceImg.currentSrc || sourceImg.src) + ')';
    clone.style.top = startRect.top + 'px';
    clone.style.left = startRect.left + 'px';
    clone.style.width = startRect.width + 'px';
    clone.style.height = startRect.height + 'px';
    document.body.appendChild(clone);

    var endX = (endRect.left + endRect.width / 2) - (startRect.left + startRect.width / 2);
    var endY = (endRect.top + endRect.height / 2) - (startRect.top + startRect.height / 2);
    var liftY = Math.min(endY, -80);

    var anim = clone.animate([
      { transform: 'translate(0, 0) scale(1)', opacity: 1, offset: 0 },
      { transform: 'translate(' + (endX * 0.55) + 'px, ' + liftY + 'px) scale(.55)', opacity: 1, offset: .55 },
      { transform: 'translate(' + endX + 'px, ' + endY + 'px) scale(.08)', opacity: .4, offset: 1 }
    ], {
      duration: 750,
      easing: 'cubic-bezier(.3, .05, .25, 1)'
    });

    anim.onfinish = function () {
      clone.remove();
      cartIcon.classList.add('equipe-cart-bump');
      window.setTimeout(function () {
        cartIcon.classList.remove('equipe-cart-bump');
      }, 350);
    };
  }

  // Il tema apre in automatico il drawer del carrello dopo ogni
  // aggiunta (ascolta lo stesso evento ajaxProduct:added). Qui non
  // tocchiamo quella logica: segnamo pero' che la richiesta di
  // apertura arriva da un click su "Aggiungi al carrello" (non da un
  // click manuale sull'icona) gia' al momento del click stesso -
  // prima ancora che parta la chiamata - cosi' non dipende dall'ordine
  // in cui i due script si mettono in ascolto di ajaxProduct:added.
  var suppressNextCartOpen = false;

  document.addEventListener('click', function (evt) {
    if (evt.target.closest('.add-to-cart')) {
      suppressNextCartOpen = true;
    }
  }, true);

  document.addEventListener('ajaxProduct:added', function () {
    flyToCart(getFlyImage());
  });

  document.addEventListener('drawerOpen.CartDrawer', function () {
    if (suppressNextCartOpen) {
      suppressNextCartOpen = false;
      document.dispatchEvent(new CustomEvent('cart:close'));
    }
  });

  // Rimozione filtro Disponibile/Esaurito ricliccando lo stesso
  // riquadro gia' selezionato. Un radio NON genera un "change"
  // ricliccando l'opzione gia' selezionata, e .checked risulta gia'
  // true al momento del "click" (il browser lo aggiorna PRIMA di
  // sparare l'evento, non dopo) - quindi non si puo' usare .checked
  // per capire se e' un nuovo click o un ri-click. Teniamo noi lo
  // stato precedente per ogni gruppo (aggiornato solo dal "change"
  // reale, che e' affidabile), e lo confrontiamo al click: se il
  // valore cliccato e' gia' quello tracciato, e' un ri-click ->
  // portiamo l'utente al vero url_to_remove di Shopify con una
  // navigazione normale (non AJAX). Qui e' sicuro passare per l'AJAX
  // del tema per una selezione/cambio normale, perche' la disponibilita'
  // tocca un solo parametro alla volta (niente rischio del bug sotto).
  var previousRadioValue = {};

  function recordRadioState() {
    previousRadioValue = {};
    document.querySelectorAll('.tag__input--removable[type="radio"]').forEach(function (radio) {
      if (radio.checked) {
        previousRadioValue[radio.name] = radio.value;
      }
    });
  }
  recordRadioState();
  document.addEventListener('collection:reloaded', recordRadioState);

  document.addEventListener('click', function (evt) {
    var input = evt.target.closest('.tag__input--removable');
    if (!input || !input.dataset.removeUrl || input.type !== 'radio') {
      return;
    }
    if (previousRadioValue[input.name] === input.value) {
      evt.preventDefault();
      window.location.href = input.dataset.removeUrl;
    }
  });

  document.addEventListener('change', function (evt) {
    var input = evt.target.closest('.tag__input--removable[type="radio"]');
    if (!input) {
      return;
    }
    previousRadioValue[input.name] = input.value;
  });

  // Filtro prezzo a fasce (checkbox) invece dello slider nativo del
  // tema: qui NON passiamo mai dall'AJAX di filtraggio del tema.
  // Motivo: cambiare fascia richiede sostituire DUE parametri insieme
  // (min e max prezzo), e la funzione del tema che calcola l'URL
  // aggiornato (getUpdatedParams in theme.js) ha un bug reale - cancella
  // voci da un URLSearchParams mentre lo sta scorrendo, e quando ci
  // sono piu' cancellazioni da fare in un colpo solo ne salta una a
  // caso. Risultato osservato: cambiando fascia, il vecchio limite
  // massimo restava nell'URL insieme al nuovo, con due valori diversi
  // per lo stesso parametro. Qui costruiamo noi l'URL corretto da zero
  // (leggendo i filtri gia' attivi da window.location.search e
  // sovrascrivendo solo min/max prezzo) e navighiamo lì direttamente -
  // stessa fascia gia' selezionata = rimozione, fascia diversa =
  // selezione/cambio. Costo: niente piu' transizione AJAX fluida per
  // il prezzo (ricarica pagina), ma e' corretto sempre.
  var previousPriceValue = {};

  function recordPriceState() {
    previousPriceValue = {};
    document.querySelectorAll('.price-bracket__input').forEach(function (radio) {
      if (radio.checked) {
        previousPriceValue[radio.name] = radio.value;
      }
    });
  }
  recordPriceState();
  document.addEventListener('collection:reloaded', recordPriceState);

  document.addEventListener('click', function (evt) {
    var input = evt.target.closest('.price-bracket__input');
    if (!input) {
      return;
    }
    var wrapper = input.closest('.price-bracket-list');
    if (!wrapper) {
      return;
    }

    evt.preventDefault();

    var isAlreadySelected = previousPriceValue[input.name] === input.value;
    var params = new URLSearchParams(window.location.search);
    var minName = wrapper.dataset.minName;
    var maxName = wrapper.dataset.maxName;

    params.delete(input.name);

    if (isAlreadySelected) {
      params.delete(minName);
      params.delete(maxName);
    } else {
      if (input.dataset.min) {
        params.set(minName, input.dataset.min);
      } else {
        params.delete(minName);
      }
      params.set(maxName, input.dataset.max);
    }

    var query = params.toString();
    window.location.href = window.location.pathname + (query ? '?' + query : '');
  });

  // Campo "Codice sconto" nel riepilogo carrello: usa la route nativa
  // di Shopify /discount/<codice>?redirect=... (nessuna app, nessuna
  // logica di calcolo nostra - e' lo stesso meccanismo dei link sconto
  // che Shopify genera per le campagne). Il codice va nel path, non in
  // query string, quindi non puo' essere un semplice <form method="get">
  // e serve costruire l'URL qui. Se applicato, redirige sul carrello
  // cosi' l'utente vede subito lo sconto riflesso prima di passare
  // al checkout.
  function applyDiscountCode() {
    var input = document.getElementById('CartDiscountCode');
    if (!input || !input.value.trim()) {
      return;
    }
    var root = (window.theme && theme.routes && theme.routes.home) || '/';
    var cartPage = (window.theme && theme.routes && theme.routes.cartPage) || '/cart';
    var base = root.replace(/\/$/, '');
    window.location.href = base + '/discount/' + encodeURIComponent(input.value.trim())
      + '?redirect=' + encodeURIComponent(cartPage);
  }

  document.addEventListener('click', function (evt) {
    if (evt.target.closest('#CartDiscountApply')) {
      applyDiscountCode();
    }
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Enter' && evt.target.id === 'CartDiscountCode') {
      evt.preventDefault();
      applyDiscountCode();
    }
  });

  // Avviso "superamento magazzino": quando si prova ad aumentare la
  // quantita' di un articolo nel carrello oltre lo stock disponibile,
  // Shopify risponde con un errore (niente item_count, solo
  // status/message) invece del carrello aggiornato. theme.js pero'
  // tratta quella risposta come se fosse un carrello valido e la
  // passa comunque dentro l'evento cart:updated - qui intercettiamo
  // quel caso e mostriamo il messaggio reale di Shopify in un
  // avviso, invece di lasciare che il numero scatti indietro senza
  // spiegazione.
  function showCartStockToast(message) {
    var existing = document.querySelector('.equipe-cart-toast');
    if (existing) {
      existing.remove();
    }
    var toast = document.createElement('div');
    toast.className = 'equipe-cart-toast';
    toast.setAttribute('role', 'alert');
    toast.textContent = message;
    document.body.appendChild(toast);

    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    window.setTimeout(function () {
      toast.classList.remove('is-visible');
      window.setTimeout(function () {
        toast.remove();
      }, 300);
    }, 5000);
  }

  // Shopify puo' anche NON restituire un errore esplicito e limitare
  // la quantita' in silenzio (risposta 200 con item.quantity minore
  // di quanto richiesto) - capita spesso, piu' del caso con errore
  // esplicito sopra. Per beccarlo serve sapere quanto era stato
  // richiesto: lo catturiamo dall'evento cart:quantity (sparato dal
  // tema PRIMA della chiamata AJAX, con lo stesso namespace per
  // pagina/drawer) e lo confrontiamo con la quantita' reale tornata
  // in cart:updated.
  var pendingQtyRequest = null;

  function trackQuantityRequest(evt) {
    pendingQtyRequest = { key: evt.detail[0], qty: evt.detail[1] };
  }
  document.addEventListener('cart:quantity.cart-page', trackQuantityRequest);
  document.addEventListener('cart:quantity.cart-undefined', trackQuantityRequest);

  document.addEventListener('cart:updated', function (evt) {
    var cart = evt.detail && evt.detail.cart;

    if (cart && cart.status && !cart.item_count && cart.message) {
      showCartStockToast(cart.message);
      pendingQtyRequest = null;
      return;
    }

    if (cart && cart.items && pendingQtyRequest) {
      var item = cart.items.filter(function (i) {
        return i.key === pendingQtyRequest.key;
      })[0];

      if (item && pendingQtyRequest.qty > item.quantity) {
        var name = item.product_title || item.title;
        var unit = item.quantity === 1 ? 'pezzo disponibile' : 'pezzi disponibili';
        showCartStockToast('Disponibilità limitata per "' + name + '": solo ' + item.quantity + ' ' + unit + '.');
      }
    }

    pendingQtyRequest = null;
  });

  // Occhiolino mostra/nascondi password nelle pagine account (login,
  // registrazione, reset e attivazione): il bottone e' il fratello
  // immediato dell'input dentro .password-field-wrapper.
  document.addEventListener('click', function (evt) {
    var toggle = evt.target.closest('.password-toggle');
    if (!toggle) {
      return;
    }
    var input = toggle.previousElementSibling;
    if (!input) {
      return;
    }
    var isVisible = input.type === 'text';
    input.type = isVisible ? 'password' : 'text';
    toggle.setAttribute('aria-pressed', String(!isVisible));
  });

  // Preloader logo in dissolvenza: solo home, solo la prima volta per sessione
  // (sessionStorage) cosi' non si ripete a ogni click sul logo/tasto indietro.
  var preloader = document.getElementById('site-preloader');
  if (preloader) {
    if (window.sessionStorage && sessionStorage.getItem('equipePreloaderShown')) {
      preloader.parentNode.removeChild(preloader);
      document.body.classList.remove('preloader-pending');
    } else {
      // La scritta usa un font di sistema (vedi equipe-custom.css), quindi
      // non serve aspettare nessun webfont: si parte subito.
      requestAnimationFrame(function () {
        preloader.classList.add('is-visible');
      });
      window.setTimeout(function () {
        preloader.classList.add('is-hidden');
        preloader.classList.remove('is-visible');
        if (window.sessionStorage) {
          sessionStorage.setItem('equipePreloaderShown', '1');
        }
      }, 3000);
      // Il banner cookie (nascosto via CSS finche' il body ha la classe
      // "preloader-pending") compare solo a dissolvenza in uscita completata:
      // 3000ms di attesa (lettere + shimmer + linea + strisce) + 1800ms di fade-out.
      window.setTimeout(function () {
        document.body.classList.remove('preloader-pending');
      }, 4800);
    }
  }
})();

/* ===== Barra acquisto fissa su mobile (scheda prodotto) =====
   Su telefono il layout e' impilato: il pulsante "Aggiungi al carrello"
   sta a meta' pagina, mentre tutto quello che convince a comprare
   (descrizione, spedizione, guida taglie, recensioni) sta sotto. Chi si
   decide leggendo deve risalire a cercare il pulsante. Questa barra lo
   riporta a portata di pollice appena esce dalla vista.

   Regola: qui dentro non c'e' nessuna logica di acquisto. Prezzo,
   etichetta e stato "esaurito" vengono letti dal blocco originale (che
   il tema aggiorna a ogni cambio variante) e il tocco inoltra il click
   al pulsante vero, quindi varianti, form e carrello ajax restano
   interamente gestiti dal tema. */
(function () {
  'use strict';

  var bar = document.querySelector('[data-sticky-atc]');
  if (!bar) {
    return;
  }

  var section = bar.closest('.product-section');
  var realBtn = section && section.querySelector('[data-add-to-cart]');
  if (!realBtn) {
    // Nessun pulsante acquisto (prodotto senza form): la barra non ha
    // niente da rispecchiare, meglio toglierla del tutto.
    bar.remove();
    return;
  }

  var realPrice = section.querySelector('[data-product-price]');
  var barBtn = bar.querySelector('[data-sticky-atc-btn]');
  var barPrice = bar.querySelector('[data-sticky-atc-price]');
  var barVariant = bar.querySelector('[data-sticky-atc-variant]');

  function syncButton() {
    var label = realBtn.querySelector('[data-add-to-cart-text]');
    var text = (label ? label.textContent : realBtn.textContent).trim();
    if (text) {
      barBtn.textContent = text;
    }
    barBtn.disabled = realBtn.disabled;
  }

  function syncPrice() {
    if (realPrice && barPrice) {
      barPrice.textContent = realPrice.textContent.trim();
    }
  }

  function syncVariant() {
    if (!barVariant) {
      return;
    }
    var checked = section.querySelectorAll('[data-variant-input]:checked');
    var values = Array.prototype.map.call(checked, function (input) {
      return input.value;
    }).filter(function (value) {
      return value && value !== 'Default Title';
    });
    barVariant.textContent = values.join(' / ');
  }

  function syncAll() {
    syncButton();
    syncPrice();
    syncVariant();
  }

  syncAll();

  // Il tema aggiorna prezzo e pulsante in place al cambio variante:
  // li seguiamo osservando i nodi veri invece di ricalcolare la
  // variante corrente per conto nostro.
  if (window.MutationObserver) {
    var observer = new MutationObserver(function () {
      syncButton();
      syncPrice();
    });
    observer.observe(realBtn, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true,
      characterData: true
    });
    if (realPrice) {
      observer.observe(realPrice, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  section.addEventListener('change', function (evt) {
    if (evt.target.closest('[data-variant-input], [data-product-select]')) {
      syncAll();
    }
  });

  // Compare solo quando il pulsante vero non e' piu' visibile.
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }).observe(realBtn);
  }

  barBtn.addEventListener('click', function () {
    if (realBtn.disabled) {
      return;
    }
    realBtn.click();
  });
})();
